module.exports = __webpack_public_path__ + "static/media/close.b80b13c5.svg";